export default __webpack_public_path__ + "static/media/v45_63.87bd47c0.png";